module.exports = __webpack_public_path__ + "media/images/fr/replace-1a96fd48a0454f081073bda4daba7faa.png";